import api from './api';

export interface PromptTemplate {
  id: string;
  name: string;
  templateContent: string;
  variablesSchema?: Record<string, unknown>;
  outputSchema?: Record<string, unknown>;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePromptTemplateData {
  name: string;
  templateContent: string;
  variablesSchema?: Record<string, unknown>;
  outputSchema?: Record<string, unknown>;
  isDefault?: boolean;
}

export interface UpdatePromptTemplateData {
  name?: string;
  templateContent?: string;
  variablesSchema?: Record<string, unknown>;
  outputSchema?: Record<string, unknown>;
  isDefault?: boolean;
}

const promptTemplatesService = {
  async getAll(): Promise<PromptTemplate[]> {
    const { data } = await api.get('/prompt-templates');
    return data.data || [];
  },

  async getById(id: string): Promise<PromptTemplate> {
    const { data } = await api.get(`/prompt-templates/${id}`);
    return data.data;
  },

  async getDefault(): Promise<PromptTemplate | null> {
    const templates = await this.getAll();
    return templates.find(t => t.isDefault) || templates[0] || null;
  },

  async create(templateData: CreatePromptTemplateData): Promise<PromptTemplate> {
    const { data } = await api.post('/prompt-templates', templateData);
    return data.data;
  },

  async update(id: string, templateData: UpdatePromptTemplateData): Promise<PromptTemplate> {
    const { data } = await api.put(`/prompt-templates/${id}`, templateData);
    return data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/prompt-templates/${id}`);
  },

  async setDefault(id: string): Promise<PromptTemplate> {
    const { data } = await api.put(`/prompt-templates/${id}/set-default`);
    return data.data;
  }
};

export default promptTemplatesService;
